import React from 'react';
import Tilt from 'react-parallax-tilt'; // Import the Tilt component
import './CoreValues.css';

const CoreValues = () => {
  return (
    <div id='core-ol'>
      <div className="cr-tp">
        <h1>Our Core Values</h1>
      </div>
      <div className="cr-grd">
        {/* <Tilt className="cr-cd" tiltMaxAngleX={15} tiltMaxAngleY={15} perspective={1000} transitionSpeed={300} glareEnable glareColor='#eee' glareReverse> */}
        <Tilt className="cr-cd" tiltMaxAngleX={15} tiltMaxAngleY={15} perspective={1000} transitionSpeed={300} >
          <div className="cr-img">
            {/* <img src="https://s3-alpha-sig.figma.com/img/7d5a/fdb8/ce2ef032f6dbb397f8941329c9c1163c?Expires=1725235200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=HhXpF5hDdOIExtV0fjEhHpIAO92-ogydTzSuvfXHduSbzMWUXRGqXRFlntb6Rc1fUJXDYP1IoccwPxYTc3mdAmXlMUy3sbbROm-Cc3995yD-0RsGyDz5afN~zkboJVtoBkmidhov9pjx0hJn6lxVbP8EGD8jzAbvaSceVqgyhUUr0DTtJoiCYvKDGLWCb0nyjQg3MPtSdAg8D2QDt69uWjWVBUmQdvnBatFJXP~okEmx5Gkisds-YGgm8a3tTIuE8qm-Np-AKDc6phAYBympsUC00dZRpijwwNTTASsh44i-CL-Xn22bpet9Jcdu1z-WdjBIdznRpF22QilTwT7U1A__" alt="Eco Friendly" /> */}
    <img src="https://i.imgur.com/53ZrRLx.gif" alt="" />
        {/* <iframe src="https://lottie.host/embed/df754b14-e3f0-410a-b6f9-6e32036cb94f/Joz0Q22kN0.json"></iframe> */}
          </div>
          <div className="cr-ttl">Sustainability</div>
          <div className="cr-para">
            We prioritize sustainable practices, ensuring our products have minimal impact on the environment.
          </div>
        </Tilt>
        <Tilt className="cr-cd" tiltMaxAngleX={15} tiltMaxAngleY={15} perspective={1000} transitionSpeed={300}>
          <div className="cr-img">
            {/* <img src="https://s3-alpha-sig.figma.com/img/7d5a/fdb8/ce2ef032f6dbb397f8941329c9c1163c?Expires=1725235200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=HhXpF5hDdOIExtV0fjEhHpIAO92-ogydTzSuvfXHduSbzMWUXRGqXRFlntb6Rc1fUJXDYP1IoccwPxYTc3mdAmXlMUy3sbbROm-Cc3995yD-0RsGyDz5afN~zkboJVtoBkmidhov9pjx0hJn6lxVbP8EGD8jzAbvaSceVqgyhUUr0DTtJoiCYvKDGLWCb0nyjQg3MPtSdAg8D2QDt69uWjWVBUmQdvnBatFJXP~okEmx5Gkisds-YGgm8a3tTIuE8qm-Np-AKDc6phAYBympsUC00dZRpijwwNTTASsh44i-CL-Xn22bpet9Jcdu1z-WdjBIdznRpF22QilTwT7U1A__" alt="Eco Friendly" /> */}
     <img src="https://i.imgur.com/yh4NzdS.gif" alt="" />
          </div>
          <div className="cr-ttl">Ethical Production</div>
          <div className="cr-para">
            Our production processes are ethical, focusing on fair labor practices and reducing waste.
          </div>
        </Tilt>
        <Tilt className="cr-cd" tiltMaxAngleX={15} tiltMaxAngleY={15} perspective={1000} transitionSpeed={300}>
          <div className="cr-img">
     <img src="https://i.imgur.com/VLufTr6.gif" alt="" />
            {/* <img src="https://s3-alpha-sig.figma.com/img/7d5a/fdb8/ce2ef032f6dbb397f8941329c9c1163c?Expires=1725235200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=HhXpF5hDdOIExtV0fjEhHpIAO92-ogydTzSuvfXHduSbzMWUXRGqXRFlntb6Rc1fUJXDYP1IoccwPxYTc3mdAmXlMUy3sbbROm-Cc3995yD-0RsGyDz5afN~zkboJVtoBkmidhov9pjx0hJn6lxVbP8EGD8jzAbvaSceVqgyhUUr0DTtJoiCYvKDGLWCb0nyjQg3MPtSdAg8D2QDt69uWjWVBUmQdvnBatFJXP~okEmx5Gkisds-YGgm8a3tTIuE8qm-Np-AKDc6phAYBympsUC00dZRpijwwNTTASsh44i-CL-Xn22bpet9Jcdu1z-WdjBIdznRpF22QilTwT7U1A__" alt="Eco Friendly" /> */}
          </div>
          <div className="cr-ttl">Renewable </div>
          <div className="cr-para">
            We use renewable resources to create our products, supporting a circular economy.
          </div>
        </Tilt>
        <Tilt className="cr-cd" tiltMaxAngleX={15} tiltMaxAngleY={15} perspective={1000} transitionSpeed={300}>
          <div className="cr-img">
    <img src="https://i.imgur.com/Fotn3hR.gif" alt="" className='gp-ad' />
            {/* <img src="https://s3-alpha-sig.figma.com/img/7d5a/fdb8/ce2ef032f6dbb397f8941329c9c1163c?Expires=1725235200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=HhXpF5hDdOIExtV0fjEhHpIAO92-ogydTzSuvfXHduSbzMWUXRGqXRFlntb6Rc1fUJXDYP1IoccwPxYTc3mdAmXlMUy3sbbROm-Cc3995yD-0RsGyDz5afN~zkboJVtoBkmidhov9pjx0hJn6lxVbP8EGD8jzAbvaSceVqgyhUUr0DTtJoiCYvKDGLWCb0nyjQg3MPtSdAg8D2QDt69uWjWVBUmQdvnBatFJXP~okEmx5Gkisds-YGgm8a3tTIuE8qm-Np-AKDc6phAYBympsUC00dZRpijwwNTTASsh44i-CL-Xn22bpet9Jcdu1z-WdjBIdznRpF22QilTwT7U1A__" alt="Eco Friendly" /> */}
          </div>
          <div className="cr-ttl">Carbon Neutral</div>
          <div className="cr-para">
            We aim to be carbon neutral by offsetting our emissions and investing in green technologies.
          </div>
        </Tilt>
      </div>
    </div>
  );
};

export default CoreValues;
